export const BLOCK_TYPES = {
  H1: { label: 'H1', style: 'header-one' },
  H2: { label: 'H2', style: 'header-two' },
  H3: { label: 'H3', style: 'header-three' },
  H4: { label: 'H4', style: 'header-four' },
  H5: { label: 'H5', style: 'header-five' },
  H6: { label: 'H6', style: 'header-six' },
  UL: {
    label: 'UL',
    style: 'unordered-list-item',
    icon: 'format_list_bulleted',
  },
  OL: { label: 'OL', style: 'ordered-list-item', icon: 'format_list_numbered' },
}

export const INLINE_STYLES = {
  BOLD: { label: 'Bold', style: 'BOLD', icon: 'format_bold' },
  ITALIC: { label: 'Italic', style: 'ITALIC', icon: 'format_italic' },
  UNDERLINE: {
    label: 'Underline',
    style: 'UNDERLINE',
    icon: 'format_underlined',
  },
}
